import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import { ListItem } from '@mui/material';

import Header from '../components/Header.js';
import Footer from '../components/Footer.js';


import {ThemeProvider} from '@mui/material/styles';
import theme from '../components/Theme.js';

function Prepare() {
  return (
    <Container>
    <ThemeProvider theme={theme}>
    <Header />

    <Container disableGutters maxWidth="md" component="main" sx={{ pt: 4, pb: 1 }}>
      <Typography component="h4" variant="h4" color="text.primary" gutterBottom>
        Preparing to work with us
      </Typography>
      <Typography component="p" variant="body1" color="text.primary">
        In general, prepare like you're taking a hike for the duration of the project.
        We usually hike in to a worksite and remain there until it's time to leave, though
        some early and late season projects cover more distance for maintenance work.
      </Typography>
      <br/>
      <Typography component="p" variant="body1" color="text.primary">
        We think you should consider the following to have an enjoyable
        time working with us.
        <List sx={{ listStyleType: 'disc'}}>
            <ListItem sx={{ display: 'list-item' }}><b>Bring a backpack.</b> You don't need to pack much but you need to have your hands free to carry tools.</ListItem>
            <ListItem sx={{ display: 'list-item' }}><b>Bring food.</b> This is probably a sandwich for a weekend project and maybe a snack for evenings. Running on empty out there is tough.</ListItem>
            <ListItem sx={{ display: 'list-item' }}><b>Bring more than enough water.</b> Even on a cool day you'll break a sweat and need to replenish fluids.</ListItem>
            <ListItem sx={{ display: 'list-item' }}><b>Be prepared for the weather.</b> We won't work in storms, but take a look at the forecast and pack whatever will keep you comfortable.</ListItem>
            <ListItem sx={{ display: 'list-item' }}><b>Wear comfortable shoes or boots.</b> No sandals or other open toed footwear.</ListItem>
            <ListItem sx={{ display: 'list-item' }}><b>Sun protection.</b> Sunscreen, sunglasses, layers, etc. Very few places we work have tree cover.</ListItem>
            <ListItem sx={{ display: 'list-item' }}><b>Personal protective equipment, or PPE.</b>
              <List sx={{ listStyleType: 'disc'}}>
                <ListItem sx={{ display: 'list-item' }}><b>Gloves!</b> We have extras, but ideally you bring your own.</ListItem>
                <ListItem sx={{ display: 'list-item' }}><b>Eye protection.</b> While not generally required, it gets dusty working in the dirt. When eye protection <i>is</i> required, such as when we're breaking rocks, we'll provide safety glasses if you don't at least have sunglasses.</ListItem>
              </List>
            </ListItem>
        </List>
      </Typography>
      <br/>
      <Typography component="p" variant="body1" color="text.primary">
        Let us know if you have any questions. We want you to have a great time working with us, and it all starts with preparedness and the right expectations.
      </Typography>
    </Container>

    <Footer />
    </ThemeProvider>
    </Container>
  );
}

export default Prepare;
